
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire44f9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire44f9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $671e2b2b281f9498$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["jkFD9","index.e160c994.js","6wUDz","hero_path.7e987a5a.jpg"]'));

function $9bfadf1d9af21c09$export$c8a8987d4410bf2d(type, props = {}, children = []) {
    const element = document.createElement(type);
    //props: {textContent: "Hello World", id: "header1", "data-productId": 123, ...}
    Object.entries(props).forEach(([key, value])=>{
        if (~key.indexOf("-")) element.setAttribute(key, value);
        else element[key] = value;
    });
    children.forEach((child)=>{
        element.appendChild(child);
    });
    return element;
}




async function $e4ed091b4d7e8031$export$e6356f2428ca1a10() {
    const response = await fetch("https://www.themealdb.com/api/json/v1/1/filter.php?c=Dessert");
    const data = await response.json();
    return data.meals;
}
async function $e4ed091b4d7e8031$export$1566d07dfb696159(id) {
    const response = await fetch(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${id}`);
    const data = await response.json();
    return data.meals[0];
}


var $7adbd11706a55bad$exports = {};
$7adbd11706a55bad$exports = new URL("hero_path.7e987a5a.jpg", import.meta.url).toString();


function $cdcf41925156a0b5$var$HomeView() {
    const hero = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7adbd11706a55bad$exports))),
        alt: "PastryPal Hero Image",
        className: "hero"
    });
    const title = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h2", {
        textContent: "Get to Know US",
        className: "title-heading"
    });
    const intro = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
        textContent: "Welcome to PastryPal, your go-to source for delightful pastry recipes! Based in the heart of the baking community, PastryPal is dedicated to helping you discover the joy of homemade baked goods. From flaky croissants to rich, decadent cakes, our mission is to provide you with easy-to-follow recipes, sourced from renowned bakers for every skill level. Whether you're a seasoned baker or just starting out, our collection features a variety of delicious options and classic pastries.",
        className: "intro-paragraph"
    });
    const invite = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
        textContent: "At PastryPal, we believe that baking should be accessible and rewarding\u2014a way to bring loved ones together, one pastry at a time. Come explore, create, and share the love of baking with us!",
        className: "intro-paragraph"
    });
    const featuredSection = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
        className: "featured-section"
    });
    (0, $e4ed091b4d7e8031$export$e6356f2428ca1a10)().then((recipes)=>{
        // Randomly select up to 4 recipes
        const selectedRecipes = recipes.sort(()=>0.5 - Math.random()).slice(0, 4);
        const recipeList = selectedRecipes.map((recipe)=>(0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
                className: "recipe-card"
            }, [
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h4", {
                    textContent: recipe.strMeal
                }),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("img", {
                    src: recipe.strMealThumb,
                    alt: recipe.strMeal
                }),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("button", {
                    textContent: "Explore More",
                    className: "explore-button",
                    onclick: ()=>{
                        window.location.hash = "#/recipes";
                    }
                })
            ]));
        featuredSection.append(...recipeList);
    });
    return (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {}, [
        hero,
        title,
        intro,
        invite,
        featuredSection
    ]);
}
var $cdcf41925156a0b5$export$2e2bcd8739ae039 = $cdcf41925156a0b5$var$HomeView;



function $7ebaadb98db65cff$var$FavoriteRecipesView() {
    const title = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h2", {
        textContent: "Your Favorite Recipes "
    });
    const favoritesSection = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
        className: "favorites-section"
    });
    let favorites = JSON.parse(localStorage.getItem("favorites")) || [];
    favorites.forEach((recipe)=>{
        const ingredientsList = Object.keys(recipe).filter((key)=>key.startsWith("strIngredient") && recipe[key]).map((key)=>`${recipe[key]}: ${recipe["strMeasure" + key.slice(13)]}`).filter((ingredient)=>ingredient.split(": ")[1] !== "");
        const recipeCard = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
            className: "recipe-card favorite-card"
        }, [
            (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h3", {
                textContent: recipe.strMeal
            }),
            (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("button", {
                textContent: "X",
                className: "remove-button",
                onclick: ()=>{
                    removeFavorite(recipe.idMeal);
                }
            }),
            (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("img", {
                src: recipe.strMealThumb,
                alt: recipe.strMeal
            }),
            (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
                textContent: "Ingredients:"
            }),
            (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("ul", {}, ingredientsList.map((ingredient)=>(0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("li", {
                    textContent: ingredient
                }))),
            (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
                textContent: recipe.strInstructions,
                className: "recipe-instructions"
            })
        ]);
        favoritesSection.appendChild(recipeCard);
    });
    if (favorites.length === 0) favoritesSection.appendChild((0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
        textContent: "You do not have favorites recipes \uD83D\uDE1E"
    }));
    function removeFavorite(idMeal) {
        favorites = favorites.filter((recipe)=>recipe.idMeal !== idMeal);
        localStorage.setItem("favorites", JSON.stringify(favorites));
        favoritesSection.innerHTML = "";
        favorites.forEach((recipe)=>{
            const ingredientsList = Object.keys(recipe).filter((key)=>key.startsWith("strIngredient") && recipe[key]).map((key)=>`${recipe[key]}: ${recipe["strMeasure" + key.slice(13)]}`).filter((ingredient)=>ingredient.split(": ")[1] !== "");
            const recipeCard = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
                className: "recipe-card"
            }, [
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h3", {
                    textContent: recipe.strMeal
                }),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("img", {
                    src: recipe.strMealThumb,
                    alt: recipe.strMeal
                }),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
                    textContent: "Ingredients:"
                }),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("ul", {}, ingredientsList.map((ingredient)=>(0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("li", {
                        textContent: ingredient
                    }))),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
                    textContent: recipe.strInstructions,
                    className: "recipe-instructions"
                }),
                (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("button", {
                    textContent: "X",
                    className: "remove-button",
                    onclick: ()=>{
                        removeFavorite(recipe.idMeal);
                    }
                })
            ]);
            favoritesSection.appendChild(recipeCard);
        });
        if (favorites.length === 0) favoritesSection.appendChild((0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
            textContent: "You do not have favorites recipes \uD83D\uDE1E"
        }));
    }
    return (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {}, [
        title,
        favoritesSection
    ]);
}
var $7ebaadb98db65cff$export$2e2bcd8739ae039 = $7ebaadb98db65cff$var$FavoriteRecipesView;




function $1354a1baa2302cc3$var$RecipesView() {
    const title = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h2", {
        textContent: "Explore All Our Recipes",
        className: "RV-title"
    });
    const recipesSection = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
        className: "RV-recipes-section"
    });
    (0, $e4ed091b4d7e8031$export$e6356f2428ca1a10)().then((recipes)=>{
        const recipesPromises = recipes.map((recipe)=>(0, $e4ed091b4d7e8031$export$1566d07dfb696159)(recipe.idMeal));
        Promise.all(recipesPromises).then((detailedRecipes)=>{
            detailedRecipes.forEach((recipe)=>{
                const ingredientsList = Object.keys(recipe).filter((key)=>key.startsWith("strIngredient") && recipe[key]).map((key)=>`${recipe[key]}: ${recipe["strMeasure" + key.slice(13)]}`).filter((ingredient)=>ingredient.split(": ")[1] !== "");
                const recipeCard = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {
                    className: "RV-recipe-card"
                }, [
                    (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h3", {
                        textContent: recipe.strMeal,
                        className: "RV-recipe-title"
                    }),
                    (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("img", {
                        src: recipe.strMealThumb,
                        alt: recipe.strMeal,
                        className: "RV-recipe-image"
                    }),
                    (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("button", {
                        className: "favorite-btn",
                        innerHTML: "&#10084;",
                        onclick: (event)=>$1354a1baa2302cc3$var$toggleFavorite(recipe, event.target)
                    }),
                    (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
                        textContent: "Ingredients: ",
                        className: "RV-ingredientH"
                    }),
                    (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("ul", {}, ingredientsList.map((ingredient)=>(0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("li", {
                            textContent: ingredient,
                            className: "RV-ingredient-item"
                        }))),
                    (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
                        textContent: recipe.strInstructions,
                        className: "RV-recipe-instructions"
                    })
                ]);
                recipesSection.appendChild(recipeCard);
            });
        });
    });
    return (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {}, [
        title,
        recipesSection
    ]);
}
function $1354a1baa2302cc3$var$toggleFavorite(recipe, button) {
    let favorites = JSON.parse(localStorage.getItem("favorites")) || [];
    const isFavorite = favorites.some((fav)=>fav.idMeal === recipe.idMeal);
    if (isFavorite) favorites = favorites.filter((fav)=>fav.idMeal !== recipe.idMeal);
    else favorites.push(recipe);
    localStorage.setItem("favorites", JSON.stringify(favorites));
    button.classList.add("shake");
    setTimeout(()=>button.classList.remove("shake"), 500);
}
var $1354a1baa2302cc3$export$2e2bcd8739ae039 = $1354a1baa2302cc3$var$RecipesView;


function $2aba70626d7b8c17$export$cf7ee87ede64229c(mainView) {
    function updateView(newView) {
        mainView.innerHTML = "";
        mainView.appendChild(newView);
    }
    function hashToRoute(hash) {
        switch(hash){
            case "#/home":
                updateView((0, $cdcf41925156a0b5$export$2e2bcd8739ae039)());
                break;
            case "#/recipes":
                updateView((0, $1354a1baa2302cc3$export$2e2bcd8739ae039)());
                break;
            case "#/favoriterecipes":
                updateView((0, $7ebaadb98db65cff$export$2e2bcd8739ae039)());
                break;
            default:
                updateView((0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h3", {
                    textContent: "404 Page Not Found"
                }));
                break;
        }
    }
    const defaultHash = window.location.hash || "#/home";
    hashToRoute(defaultHash);
    window.addEventListener("hashchange", (evt)=>{
        const newUrl = new URL(evt.newURL);
        const hash = newUrl.hash;
        hashToRoute(hash);
    });
}


function $356909101a1d332e$var$Header() {
    const appTitle = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("h1", {
        textContent: "PastryPal",
        className: "heading"
    });
    // nav items
    const homeLink = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("a", {
        href: "#/home",
        textContent: "Home"
    });
    const recipeLink = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("a", {
        href: "#/recipes",
        textContent: "Recipes"
    });
    const favoriterecipesLink = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("a", {
        href: "#/favoriterecipes",
        textContent: "Favorites"
    });
    const nav = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("nav", {}, [
        homeLink,
        recipeLink,
        favoriterecipesLink
    ]);
    return (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("header", {}, [
        appTitle,
        nav
    ]);
}
function $356909101a1d332e$var$Footer() {
    const copyright = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("span", {
        textContent: `\xa9 ${new Date().getFullYear()} PastryPal`
    });
    const footerP = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
        textContent: "All rights reserves"
    });
    const lastModification = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
        textContent: `Last Modification: ${new Date().toLocaleString()}`
    });
    const contactInfo = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {}, [
        (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
            textContent: "Contact Us"
        }),
        (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
            textContent: "Phone: +51 916 165 703"
        }),
        (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
            textContent: "Email: pastrypal@gmail.com"
        }),
        (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {
            textContent: "Address: 6711 Abanto St, Carlsbad, CA 92009"
        })
    ]);
    const credit = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("p", {}, [
        (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("a", {
            href: "https://www.themealdb.com/",
            textContent: "Themealdb",
            target: "_blank"
        })
    ]);
    return (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("footer", {}, [
        contactInfo,
        credit,
        copyright,
        footerP,
        lastModification
    ]);
}
function $356909101a1d332e$var$App() {
    const main = (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("main", {}, []);
    (0, $2aba70626d7b8c17$export$cf7ee87ede64229c)(main);
    return (0, $9bfadf1d9af21c09$export$c8a8987d4410bf2d)("div", {}, [
        $356909101a1d332e$var$Header(main),
        main,
        $356909101a1d332e$var$Footer()
    ]);
}
document.getElementById("root").appendChild($356909101a1d332e$var$App());
var $356909101a1d332e$export$2e2bcd8739ae039 = $356909101a1d332e$var$App;


//# sourceMappingURL=index.e160c994.js.map
